import React from 'react';
import AppSidebar from '../../../components/layout/AppSidebar';
import ChatHistorySidebar from '../../../components/ChatHistorySidebar';
import { useWorkspaceContext } from '../providers/WorkspaceProvider';
import { usePreviewContext } from '../providers/PreviewProvider';
import { useChatContext } from '../providers/ChatProvider';
import { useAppContext } from '../../../context/AppContext';

export default function LeftSidebar() {
  const {
    activeTab,
    setActiveTab,
    mobileTab,
    setMobileTab,
    showHistorySidebar,
    setShowHistorySidebar,
    authToken,
    user,
    theme,
    toggleTheme,
    handleLogout,
    credits,
    setShowPricing,
    setShowCustomize,
  } = useWorkspaceContext();

  const {
    atsScore,
    variants,
    activeVariantId,
    coverTemplate,
    setCoverTemplate,
    handleSelectVariant,
    handleDeleteVariant,
    handleCreateVariant,
    coverLetters,
  } = usePreviewContext();

  const {
    setReply,
    setCurrentSessionId,
    currentSessionId,
    handleClearChat,
  } = useChatContext();

  const { triggerImportModal } = useAppContext();

  const handleTabChange = (tab) => {
    if (tab === 'chat_history') {
      setShowHistorySidebar(true);
    } else if (tab === 'pricing') {
      setShowPricing?.(true);
    } else {
      setActiveTab(tab);
      if (window.innerWidth < 768) {
        // If the tab is exclusively rendered in RightWorkspace (which hides CenterWorkspace),
        // we must switch the mobile view to RightWorkspace (mobileTab = 2) so it's visible.
        const rightOnlyTabs = ['home', 'assets_vault', 'tracker', 'career_memory', 'profile', 'career_intelligence', 'audit'];
        if (rightOnlyTabs.includes(tab)) {
          setMobileTab(2);
        } else {
          setMobileTab(1);
        }
      }
    }
  };

  return (
    <>
      {/* Chat History Sidebar */}
      <ChatHistorySidebar
        isOpen={showHistorySidebar}
        onClose={() => setShowHistorySidebar(false)}
        authToken={authToken}
        currentSessionId={currentSessionId}
        onSelectSession={async (session) => {
          setCurrentSessionId(session.id);
          try {
            const token = authToken || localStorage.getItem('auth_token');
            const res = await fetch(`/api/chat/sessions/${session.id}`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            if (res.ok) {
              const data = await res.json();
              if (data.messages) {
                setReply(data.messages);
              }
            }
          } catch (err) {
            console.error("Failed to load chat history session:", err);
          }
        }}
        onNewChat={() => {
          handleClearChat();
          setCurrentSessionId(null);
        }}
        onDeleteSession={(deletedId) => {
          if (currentSessionId === deletedId) {
            setCurrentSessionId(null);
            setReply([]);
            try {
              localStorage.removeItem('rz_resume');
              localStorage.removeItem('rz_reply');
            } catch {}
          }
        }}
      />

      <style>{`
        @media (max-width: 768px) {
          .app-sidebar-container aside {
            width: 100% !important;
            max-width: 100% !important;
            border-right: none !important;
          }
        }
      `}</style>
      <div className={`app-sidebar-container ${mobileTab === 0 ? 'flex flex-1 w-full z-20 pb-[56px] md:pb-0' : 'hidden'} md:flex md:w-auto shrink-0`}>
        <AppSidebar
          activeTab={activeTab}
          onTabChange={handleTabChange}
          atsScore={atsScore}
          credits={credits ?? 0}
          user={user}
          theme={theme}
          toggleTheme={toggleTheme}
          onLogout={handleLogout}
          variants={variants}
          activeVariantId={activeVariantId}
          onSelectVariant={handleSelectVariant}
          onDeleteVariant={handleDeleteVariant}
          onCreateVariant={handleCreateVariant}
          onClearChat={handleClearChat}
          onImportResume={triggerImportModal}
          onUpgrade={() => setShowPricing?.(true)}
          coverTemplate={coverTemplate}
          setCoverTemplate={setCoverTemplate}
          onOpenCustomize={() => setShowCustomize?.(true)}
          coverLetters={coverLetters}
        />
      </div>
    </>
  );
}
